import React, { useState } from "react";
import { Link } from 'react-router-dom'
import Events from '../../api/events'
import EventBookingModal from '../EventBookingModal/EventBookingModal'
import cImag from '../../images/testimonial/shape-1.png'
import cImag2 from '../../images/testimonial/shape-2.png'


const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const EventSection = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);

    const handleBookSeat = (event) => {
        setSelectedEvent(event);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedEvent(null);
    };

    return (
        <div className="wpo-event-area section-padding">
            <div className="container">
                <div className="wpo-event-wrap">
                    <div className="row">
                        {Events.map((event, evt) => (
                            <div className="col col-lg-4 col-md-6 col-12" key={evt}>
                                <div className="wpo-event-item">
                                    <div className="wpo-event-header">
                                        <div className="event-category">
                                            <span>{event.thumb}</span>
                                        </div>
                                        <div className="event-date">
                                            <h5>{event.month}</h5>
                                            <span>{event.date}</span>
                                        </div>
                                    </div>
                                    <div className="wpo-event-content">
                                        <h2><span>{event.title}</span></h2>
                                        <div className="event-meta">
                                            <div className="event-time">
                                                <i className="fi fa fa-clock-o" aria-hidden="true"></i>
                                                <span>{event.time}</span>
                                            </div>
                                            <div className="event-duration">
                                                <i className="fi flaticon-calendar" aria-hidden="true"></i>
                                                <span>{event.duration}</span>
                                            </div>
                                        </div>
                                        <button onClick={() => handleBookSeat(event)} className="more">Book A Seat</button>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </div>
            <div className="shape-1"><img src={cImag} alt=""/></div>
            <div className="shape-2"><img src={cImag2} alt=""/></div>
            
            <EventBookingModal 
                isOpen={isModalOpen} 
                onClose={closeModal} 
                eventTitle={selectedEvent?.title || ''} 
            />
        </div>
    );
}

export default EventSection;